export default __webpack_public_path__ + "static/media/white-texture.b31db322.webp";